import { OnboardingDocumentsItem } from 'commons/types/DTO/bank/applications/manage/OnboardingDocumentsItem'
import { DateTime, Link, TableColumn } from 'ui/components'

import { Actions } from './components/Actions'
import { StatusBadge } from './components/StatusBadge'

export const columns = (applicationId: number): TableColumn<OnboardingDocumentsItem>[] => [
  {
    title: 'ID',
    align: 'left',
    render: ({ id }) => (
      <Link
        to="/application/$applicationId/onboarding-documents/$id/details"
        params={{ applicationId: applicationId.toString(), id: id.toString() }}
      >
        ID-{id}
      </Link>
    )
  },
  {
    title: 'Documents Count',
    align: 'left',
    render: ({ documentsCount }) => <>{documentsCount}</>
  },
  {
    title: 'Status',
    align: 'left',
    render: ({ status }) => <StatusBadge status={status} />
  },
  {
    title: 'Created',
    align: 'left',
    render: ({ createdAt }) => <DateTime date={createdAt} withTime />
  },
  {
    title: 'Sent to Sign',
    align: 'left',
    render: ({ sentAt }) => (sentAt ? <DateTime date={sentAt} withTime /> : <>---</>)
  },
  {
    title: 'Action(s)',
    align: 'center',
    render: (item) => <Actions item={item} applicationId={applicationId} />
  }
]
